import { ModalFooter, ModalFooterButton } from '@/components/Modal'

import { useController } from '../hooks/useController'
import { useDeleteTrafficAreas } from '../hooks/useDeleteTrafficAreas'

import { useTexts } from '../useTexts'

export function Footer() {
  const texts = useTexts()
  const { status, close } = useController()
  const deleteTrafficArea = useDeleteTrafficAreas()

  return (
    <ModalFooter
      primaryAction={
        <ModalFooterButton
          disabled={status !== 'ready'}
          onClick={deleteTrafficArea}
          variant="contained"
          testid="delete-modal-confirm-button"
          color="error"
        >
          {texts.confirmButtonTitle}
        </ModalFooterButton>
      }
      secondaryAction={
        <ModalFooterButton onClick={close} testid="delete-modal-cancel-button">
          {texts.cancelButtonTitle}
        </ModalFooterButton>
      }
    />
  )
}
